export function mapToArray<T>(map: Map<string, T> | undefined): T[] {
    if (!map) {
        return [];
    }
    return Array.from(map.values());
}
